import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchDataVisualizationsTypes = getApiActionTypes('FETCH_DATA_VISUALIZATIONS_TO_RUN');
export const fetchDataVisualizationTypes = getApiActionTypes('FETCH_DATA_VISUALIZATION_TO_RUN');
